import { useTranslation } from 'react-i18next'
import { Press } from '@dorixona/ui'
import { spendDigits } from './model'
import { usePoints } from '../../ui/points'

export interface SpendFieldProps {
  on: boolean
  /** Что введено в поле; при включении там потолок, пусто — ничего не списываем. */
  text: string
  /** Потолок списания из расчёта сервера. */
  max: number
  balance: number
  maxPct: number
  onToggle: (on: boolean) => void
  onText: (text: string) => void
}

/**
 * Списание баллов: переключатель, а под ним поле суммы. Включили — в поле
 * потолок; можно ввести меньше, «Все баллы» возвращает потолок. Больше потолка
 * поле не оставит.
 */
export function SpendField({ on, text, max, balance, maxPct, onToggle, onText }: SpendFieldProps) {
  const { t } = useTranslation('checkout')
  const { formatPoints } = usePoints()
  const over = Number(text) > max

  return (
    <div className="card">
      <label className="spend">
        <div>
          <div className="t1">{t('checkout:spendToggle')}</div>
          <div className="t2">
            {t('checkout:spendHint', { balance: formatPoints(balance), pct: maxPct })}
          </div>
        </div>
        <span className="switch">
          <input
            type="checkbox"
            role="switch"
            aria-label={t('checkout:spendToggle')}
            checked={on}
            onChange={(event) => {
              onToggle(event.target.checked)
            }}
          />
          <span className="tr2" />
          <span className="th" />
        </span>
      </label>

      {on ? (
        <div className="spend-amount">
          <div className="spend-box">
            <input
              className="num"
              inputMode="numeric"
              autoComplete="off"
              placeholder="0"
              aria-label={t('checkout:spendAmount')}
              value={text}
              onChange={(event) => {
                onText(spendDigits(event.target.value))
              }}
              onBlur={() => {
                if (over) onText(String(max))
              }}
            />
            {text !== String(max) ? (
              <Press
                squish="chip"
                className="spend-all"
                onPress={() => {
                  onText(String(max))
                }}
              >
                {t('checkout:spendAll')}
              </Press>
            ) : null}
          </div>
          <div className="t2">
            {t(over ? 'checkout:spendCapped' : 'checkout:spendUpTo', {
              amount: formatPoints(max),
            })}
          </div>
        </div>
      ) : null}
    </div>
  )
}
